module.exports = __webpack_public_path__ + "img/phone-screen-id.6b25f93b.png";